import React, { useEffect, useState } from "react";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import Container from "../../../../layouts/containers/Container";
import baseUrl from "../../../../api/baseUrl";
import BottomTab from "../../../../components/pagination/BottomTab";
import TabBar from "../../../../components/tabbar/TabBar";
import TreatmentListTr from "./TreatmentListTr";
import SearchIcon from "@mui/icons-material/Search";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import EventIcon from "@mui/icons-material/Event";
import SettingsIcon from "@mui/icons-material/Settings";

interface Patient {
  regNo: string;
  fullName: string;
  address: string;
  nic: string;
  whatsapp: string;
  _id: string;
}

function TreatmentList() {
  const [predata, setpreData] = useState<Patient[]>([]);
  const [page, setpage] = useState(1);
  const [count, setcount] = useState(0);
  const [search, setsearch] = useState("");
  const [type, settype] = useState("all");

  const getdata = (search: any, pages: any) => {
    baseUrl
      .get("patient/findPatientsTreatment", {
        headers: {
          keyword: search,
          page: pages,
        },
      })
      .then((response) => {
        setpreData(response.data.preTreatment);
        setcount(response.data.treatmentCount);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getdata("", page);
  }, []);

  const onPageChange = (e: any) => {
    getdata("", e);
    setpage(e);
  };

  const onSearch = (e: any) => {
    getdata(e.target.value, page);
    setsearch(e.target.value);
  };

  const filterOptions = [
    { value: "all", label: "All" },
    { value: "planned", label: "Planned" },
    { value: "ongoing", label: "Ongoing" },
    { value: "complete", label: "Complete" },
  ];

  return (
    <CommonLayout>
      <TabBar title={"Treatment List"} />

      {/* Search and Filters */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-3 mt-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          {/* Search */}
          <div className="relative flex-1 max-w-md">
            <SearchIcon
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              sx={{ fontSize: 16 }}
            />
            <input
              type="search"
              onChange={onSearch}
              value={search}
              placeholder="Search patient..."
              className="w-full pl-10 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-xs"
            />
          </div>

          {/* Filter Buttons */}
          <div className="flex gap-2 flex-wrap">
            {filterOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => settype(option.value)}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                  type === option.value
                    ? "bg-indigo-500 text-white shadow-md shadow-indigo-200"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>

          {/* Count Badge */}
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 rounded-lg">
            <MedicalServicesIcon
              className="text-indigo-500"
              sx={{ fontSize: 16 }}
            />
            <span className="font-bold text-indigo-600 text-xs">{count}</span>
            <span className="text-slate-500 text-xs">Treatments</span>
          </div>
        </div>
      </div>
      {/* Table */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden mt-3">
        {/* Mobile Cards */}
        <div className="md:hidden p-3 space-y-2">
          {predata.length === 0 ? (
            <div className="text-center py-8 text-slate-400">
              <MedicalServicesIcon sx={{ fontSize: 36 }} className="mb-2" />
              <p className="text-xs">No treatments found</p>
            </div>
          ) : (
            predata
              .filter((item: any) => type === "all" || item.status === type)
              .map((item: any, i: number) => (
                <TreatmentListTr
                  key={i}
                  item={item}
                  setpreData={setpreData}
                  isMobile
                />
              ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Reg No
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <PersonIcon sx={{ fontSize: 14 }} />
                    Patient
                  </div>
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <PhoneIcon sx={{ fontSize: 14 }} />
                    Mobile
                  </div>
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <LocalHospitalIcon sx={{ fontSize: 14 }} />
                    Dentist
                  </div>
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <EventIcon sx={{ fontSize: 14 }} />
                    Date
                  </div>
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1.5">
                    <SettingsIcon sx={{ fontSize: 14 }} />
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {predata.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="px-3 py-8 text-center text-slate-400"
                  >
                    <MedicalServicesIcon
                      sx={{ fontSize: 36 }}
                      className="mb-2"
                    />
                    <p className="text-xs">No treatments found</p>
                  </td>
                </tr>
              ) : (
                predata
                  .filter((item: any) => type === "all" || item.status === type)
                  .map((item: any, i: number) => (
                    <TreatmentListTr
                      key={i}
                      item={item}
                      setpreData={setpreData}
                    />
                  ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="border-t border-slate-100">
          <BottomTab
            title={"Treatments"}
            count={count}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </CommonLayout>
  );
}

export default TreatmentList;
